import { NgModule } from '@angular/core';
import { MeHeaderComponent } from './me-header.component';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        BaseModule,
        RouterModule,
        StoryBlokLinkModule
    ],
    declarations: [
        MeHeaderComponent
    ],
    exports: [
        MeHeaderComponent
    ]
})
export class MeHeaderModule { }
